import {
  REGET,
  GROUPTEMPLATELIST,
  SETTINGPROJECTS,
  SELECTEDPROJECTUNITS,
  SETTINGSELECTEDPROJECT,
  SETTINGGLASSES,
} from "Stores/actionTypes";
import StatusHandler from "Helpers/StatusHandler";
import { translatorf } from "Languages/Utility/translatorf";
import showNotify from "Helpers/Notify";
import ShopService from "Services/http/endpoints/properties/ShopService";
import CustomerService from "Services/http/endpoints/customer/CustomerService";
import ProjectService from "Services/http/endpoints/project/ProjectService";
import FactorService from "Services/http/endpoints/factor/FactorService";
import PatternService from "Services/http/endpoints/pattern/PatternService";

export const getFrameTemplates = (params) => {
  return async () => {
    try {
      const response = await ShopService.getFrameTemplates(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        const updatedData = data.map((item) => {
          return {
            ...item,
            value: item.Id,
            label: item.Name,
          };
        });
        return updatedData;
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const getGroupTemplates = (params) => {
  return async (dispatch) => {
    try {
      const response = await ShopService.getGroupTemplates(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        const updatedData = data.map((data, index) => {
          return {
            ...data,
            num: index,
          };
        });
        dispatch({
          type: GROUPTEMPLATELIST,
          list: updatedData,
          pagination: response.data.Pagination,
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const insertGroupTemplate = (data) => {
  return async (dispatch) => {
    try {
      const response = await ShopService.insertGroupTemplate(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch({
          type: REGET,
          Id: "GroupTemplate",
          status: true,
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const editGroupTemplate = (data) => {
  return async (dispatch) => {
    try {
      const response = await ShopService.editGroupTemplate(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch({
          type: REGET,
          Id: "GroupTemplate",
          status: true,
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const deleteGroupTemplate = (data) => {
  return async (dispatch) => {
    try {
      const response = await ShopService.deleteGroupTemplate(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch({
          type: REGET,
          Id: "GroupTemplate",
          status: true,
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const getComboTemplates = (params) => {
  return async () => {
    try {
      const response = await ShopService.getComboTemplates(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        const updatedData = data.map((item) => {
          return {
            ...item,
            value: item.Id,
            label: item.Name,
          };
        });
        return updatedData;
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const getTemplates = (params) => {
  return async (dispatch) => {
    try {
      const response = await ShopService.getTemplates(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        const updatedData = data.map((data, index) => {
          return {
            ...data,
            num: index,
          };
        });
        return {
          list: updatedData,
          pagination: response.data.Pagination,
        };
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const insertTemplate = (data) => {
  return async (dispatch) => {
    try {
      const response = await ShopService.insertTemplate(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf("mission_accomplished"),
          customClass: "success",
        });
        return true;
      } else return false;
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const editTemplate = (data) => {
  return async (dispatch) => {
    try {
      const response = await ShopService.editTemplate(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf("mission_accomplished"),
          customClass: "warning",
        });
        return true;
      } else return false;
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const deleteTemplate = (data) => {
  return async (dispatch) => {
    try {
      const response = await ShopService.deleteTemplate(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf("mission_accomplished"),
          customClass: "warning",
        });
        return true;
      } else return false;
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const getSettingProjectsCustomers = (params) => {
  return async (dispatch) => {
    try {
      const response = await CustomerService.getComboMoshtari(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        const updatedData = data
          .filter((item) => item.Id > 0)
          .map((item) => {
            return {
              ...item,
              value: item.Id,
              label: item.Name,
            };
          });
        return updatedData;
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const getSettingProjectsCustomersProjects = (params) => {
  return async (dispatch) => {
    try {
      const response = await ProjectService.selectProjectComboWitIdCustomer(
        params
      );
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        const updatedData = data.map((item) => {
          return {
            ...item,
            value: item.Id,
            label: item.Name,
          };
        });
        return updatedData;
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const getSettingProjects = (params) => {
  return async (dispatch) => {
    try {
      const response = await ShopService.getSettingProjects(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        dispatch({
          type: SETTINGPROJECTS,
          list: data,
          pagination: response.data.Pagination,
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const insertSettingProject = (data) => {
  return async (dispatch) => {
    try {
      const response = await ShopService.insertSettingProject(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch({
          type: REGET,
          Id: "SettingProject",
          status: true,
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const editSettingProject = (data) => {
  return async (dispatch) => {
    try {
      const response = await ShopService.editSettingProject(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch({
          type: REGET,
          Id: "SettingProject",
          status: true,
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const deleteSettingProject = (data, selected) => {
  return async (dispatch) => {
    try {
      const response = await ShopService.deleteSettingProject(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch({
          type: REGET,
          Id: "SettingProject",
          status: true,
        });
        if (selected) {
          dispatch({
            type: SELECTEDPROJECTUNITS,
            list: [],
          });
          dispatch({
            type: SETTINGSELECTEDPROJECT,
            project: null,
          });
        }
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const getSettingProjects_selectedProjectUnits = (params) => {
  return async (dispatch) => {
    try {
      const response = await FactorService.getUnitListWithImg(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        dispatch({
          type: SELECTEDPROJECTUNITS,
          list: data,
          pagination: response.data.Pagination,
        });
      }
    } catch (e) {
      console.log(e);
    }
  };
};

export const getUnitInfo = (params) => {
  return async (dispatch) => {
    try {
      const response = await ShopService.getSettingUnitInfo(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        return response.data.Value;
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const updateUnitInfo = (data) => {
  return async (dispatch) => {
    try {
      const response = await ShopService.updateSettingUnitInfo(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf("mission_accomplished"),
          customClass: "success",
        });
        return true;
      } else return false;
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const getSettingUnitAttachments = (params) => {
  return async (dispatch) => {
    try {
      const response = await ShopService.getSettingUnitAttachments(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        return response.data.Value;
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const insertSettingUnitAttachment = (data) => {
  return async (dispatch) => {
    try {
      const response = await ShopService.insertSettingUnitAttachment(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf("mission_accomplished"),
          customClass: "success",
        });
        return true;
      } else return false;
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const editSettingUnitAttachment = (data) => {
  return async (dispatch) => {
    try {
      const response = await ShopService.editSettingUnitAttachment(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf("mission_accomplished"),
          customClass: "warning",
        });
        return true;
      } else return false;
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const deleteSettingUnitAttachment = (data) => {
  return async (dispatch) => {
    try {
      const response = await ShopService.deleteSettingUnitAttachment(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf("mission_accomplished"),
          customClass: "warning",
        });
        return true;
      } else return false;
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};


export const getComboGlassGroup = (params) => {
  return async (dispatch) => {
    try {
      const response = await PatternService.getShisheGroup(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        const updatedData = data.map((item) => {
          return {
            ...item,
            value: item.Id,
            label: item.Name,
          };
        });
        return updatedData;
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const getComboGlass_Id = (params) => {
  return async (dispatch) => {
    try {
      const response = await PatternService.getGlass(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        const updatedData = data.map((item) => {
          return {
            ...item,
            value: item.Id,
            label: item.Name,
          };
        });
        return updatedData;
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const getSettingGlasses = (params) => {
  return async (dispatch) => {
    try {
      const response = await ShopService.getSettingGlasses(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        dispatch({
          type: SETTINGGLASSES,
          list: data,
          pagination: response.data.Pagination,
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const insertSettingGlass = (data) => {
  return async (dispatch) => {
    try {
      const response = await ShopService.insertSettingGlass(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch({
          type: REGET,
          Id: "SettingGlass",
          status: true,
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const editSettingGlass = (data) => {
  return async (dispatch) => {
    try {
      const response = await ShopService.editSettingGlass(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch({
          type: REGET,
          Id: "SettingGlass",
          status: true,
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const deleteSettingGlass = (data) => {
  return async (dispatch) => {
    try {
      const response = await ShopService.deleteSettingGlass(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch({
          type: REGET,
          Id: "SettingGlass",
          status: true,
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};
